"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.commaJoin = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
function commaJoin(arr, joiner = lib_i18n_1.default.t('and')) {
    if (arr.length < 3)
        return arr.join(` ${joiner} `);
    const clone = [...arr];
    const last = clone.splice(arr.length - 1, 1);
    return `${clone.join(', ')} ${joiner} ${last}`;
}
exports.commaJoin = commaJoin;
exports.default = commaJoin;
